import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GeneralService } from './general.service';
@Injectable()
export class PaymentService {
  public tuition;
  public summary;
  constructor(private http: HttpClient,
    private _generalService: GeneralService
  ) { }

  public payment_controls = [
    { key: 'course_reg', description: 'Minimum payment percentage value for allowing course registration' },
    { key: 'result', description: 'Minimum payment percentage value for allowing result viewing' },
    { key: 'exam', description: 'Minimum payment percentage value for Tests and Examination' },
    { key: 'resources', description: 'Minimum payment percentage value for allowing access to resources' },
    { key: 'timetable', description: 'Minimum payment percentage value for allowing access to timetable' },
    { key: 'election', description: 'Minimum payment percentage value for allowing access to election' },
    { key: 'part_payment', description: 'Minimum payment percentage value allowed as part payment in tuition' }
  ]

  getPaymentClearanceOffices() {
    return this._generalService.requestWithCache(
      this.http.get<any>("/edozzier/portal-get-payment-clearance-offices.php"),
      { request: "getPaymentClearanceOffices" }
    )
  }

  getFeeDetails() {
    return this.http.get<any>('/edozzier/portal-fee-details.php');
  }

  getAddedPayment(data) {
    return this.http.post<any>('/edozzier/portal-get-added-payments.php', data);
  }

  makePayment(data) {
    return this.http.get<any>('/edozzier/portal-pay-fees.php', data);
  }

  requeryTuitionPayment(data) {
    return this.http.post<any>('/edozzier/portal-requery-tuition-payment.php', data);
  }

  makeAppPayment(data = null) {
    return this.http.post<any>('/edozzier/portal-pay-app-fees.php', data);
  }

  makePenaltyPayment(totalPenaltyFee) {
    return this.http.post<any>("/edozzier/paystack/initialize.php", totalPenaltyFee);
  }

  purposeOfPayment(p) {
    return this.http.post<any>("/edozzier/paymentPurpose.php", p);
  }
  isPenaltyPaid() {
    return this.http.get<any>("/edozzier/portal-checkIfPenaltyIsPaid.php");
  }

  handleInterswitchPayment() {
    return this.http.get<any>("/edozzier/portal-pay-tuition.php");
  }

  tuitionPaid() {
    return this.http.get<any>('/edozzier/portal-tuition-paid.php');
  }

  transactionHistory() {
    return this.http.get<any>('/edozzier/portal-tuition-history.php');
  }

  studentPaymentHistory() {
    return this.http.get<any>('/edozzier/portal-payment-history.php');
  }

  verifyPayment(data) {
    return this.http.post<any>('/edozzier/portal-verify-payment.php', data)
  }

  makePaymentByReference(data) {
    return this.http.post<any>('/edozzier/portal-make-payment-by-reference.php', data)
  }

  getCompanyAccounts() {
    return this.http.get<any>('/edozzier/portal-get-company-accounts.php')
  }

  getPaymentPercentage() {
    return this.http.get<any>('/edozzier/portal-get-payment-percentage.php')
  }

  getPaymentControls() {
    return this.http.get<any>('/edozzier/portal-get-payment-controls.php')
  }

  getPaymentEligibility(key) {
    return this.http.post<any>('/edozzier/portal-get-feature-eligibility.php', key)
  }

  getPaymentPercentageByTerm(key) {
    return this.http.post<any>('/edozzier/portal-get-term-payment-percentage.php', key)
  }

  getUploadedPayments(data) {
    return this.http.post<any>('/edozzier/portal-get-uploaded-payments.php', data)
  }

  uploadPayslip(data) {
    return this.http.post<any>('/edozzier/portal-upload-payslip.php', data)
  }

  recordPayment(data) {
    return this.http.post<any>('/edozzier/portal-record-payment.php', data)
  }

  confirmRecipient(data) {
    return this.http.post<any>('/edozzier/portal-confirm-recipient.php', data)
  }

  confirmPaymentTransfer(data) {
    return this.http.post<any>('/edozzier/portal-confirm-payment-transfer.php', data)
  }

  getPaymentTransfers(data) {
    return this.http.post<any>('/edozzier/portal-get-payment-transfers.php', data)
  }

  deleteTransfer(data) {
    return this.http.post<any>('/edozzier/portal-delete-payment-transfer.php', data)
  }

  paymentTransferAction(data) {
    return this.http.post<any>('/edozzier/portal-payment-transfer-action.php', data)
  }
  getStudentPaymentHistory(data) {
    return this.http.post<any>('/edozzier/portal-get-student-payment-history.php', data);
  }
  // getPaymentEligibility(key): any{
  //   this.getPaymentControls().subscribe(data => {
  //     let control = data.filter(d => d.key == key);
  //     if(control.length > 0){
  //       this.getPaymentPercentage().subscribe(data => {
  //         let payment_percentage = data.payment_percentage;
  //         if(payment_percentage >= control[0].control_value){
  //           return {control: true};
  //         }else{
  //           return {control: false, value: control[0].control_value};
  //         }
  //       })
  //     }else{
  //       return {control: true}
  //     }
  //   })
  // }



}
